export default {
  DK: 37,
};



// WEBPACK FOOTER //
// ./src/variables/itineraryPrices/elcanoDefaultDomainIds.js